import { render } from "./ToolBox.vue?vue&type=template&id=5567554c"
import script from "./ToolBox.vue?vue&type=script&lang=js"
export * from "./ToolBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__